// Muestra los datos guardados localmente en un modal.
export default function cargaDatosLocal(feature, { map, customPointsLayer } = {}) {
  const props = feature.getProperties() || {};
  const titulo = props.titulo || "(sin título)";
  const descripcion = props.descripcion || "(sin descripción)";
  const coords = feature.getGeometry().getFlatCoordinates();
  const modal = `
    <div id="modalInfoLocal" tabindex="-1" class="fixed inset-0 flex items-center justify-center z-50 mx-2">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-lg">
        <div class="p-4 md:p-5">
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-semibold">Información local</h3>
            <button type="button" id="cerrarModalInfoLocal" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center">
              <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
            </button>
          </div>
          <div class="p-4 md:p-5 space-y-4">
            <p class="py-0.5">Coordenadas: <b>${coords[0].toFixed(3)}, ${coords[1].toFixed(3)}</b></p>
            <div>
              <label class="block text-sm font-medium mb-2">Título</label>
              <p class="py-2">${titulo}</p>
            </div>
            <div>
              <label class="block text-sm font-medium mb-2">Descripción</label>
              <p class="py-2">${descripcion}</p>
            </div>
            <div class="flex justify-center pt-4 space-x-4" style="gap:16px;">
              <button id="botonEliminarInfoLocal" type="button" class="text-white bg-red-600 hover:bg-red-700 font-medium rounded-lg text-sm px-5 py-2.5 h-10 w-40">Eliminar</button>
              <button id="botonEliminarTodosInfoLocal" type="button" class="text-white bg-red-800 hover:bg-red-900 font-medium rounded-lg text-sm px-5 py-2.5 h-10 w-40 inline-flex items-center justify-center gap-2">⚠️ Eliminar todos</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML("beforeend", modal);

  document.getElementById("cerrarModalInfoLocal").addEventListener("click", () => {
    const modalElement = document.getElementById("modalInfoLocal");
    if (modalElement) modalElement.remove();
  });

  const botonEliminar = document.getElementById("botonEliminarInfoLocal");
  if (botonEliminar) {
    let esLocal = false;
    try {
      const puntosGuardados = JSON.parse(localStorage.getItem("puntosGuardados")) || [];
      const creado = feature.get("creado");
      const fx = Number(coords[0]);
      const fy = Number(coords[1]);
      esLocal = puntosGuardados.some((item) => {
        if (Array.isArray(item) && item.length >= 2) {
          return Number(item[0]) === fx && Number(item[1]) === fy;
        }
        if (item && item.coordenadas) {
          if (creado && item.creado && String(item.creado) === String(creado)) return true;
          return Number(item.coordenadas[0]) === fx && Number(item.coordenadas[1]) === fy;
        }
        return false;
      });
    } catch (error) {
      esLocal = false;
    }

    if (!esLocal) {
      botonEliminar.style.display = "none";
    } else {
      botonEliminar.addEventListener("click", () => {
        if (!confirm("¿Eliminar este punto? Esta acción no se puede deshacer.")) return;

        try {
          if (customPointsLayer && customPointsLayer.getSource) {
            try { customPointsLayer.getSource().removeFeature(feature); } catch (error) {}
            try { customPointsLayer.getSource().changed(); } catch (error) {}
          } else if (map) {
            map.getLayers().getArray().forEach((layer) => {
              try {
                if (layer && layer.getSource && layer.getSource().removeFeature) {
                  layer.getSource().removeFeature(feature);
                }
              } catch (error) {}
            });
          }
        } catch (error) {}

        try {
          const puntosGuardados = JSON.parse(localStorage.getItem("puntosGuardados")) || [];
          const creado = feature.get("creado");
          const fx = Number(coords[0]);
          const fy = Number(coords[1]);
          const nueva = puntosGuardados.filter((item) => {
            if (Array.isArray(item) && item.length >= 2) {
              return !(Number(item[0]) === fx && Number(item[1]) === fy);
            }
            if (item && item.coordenadas) {
              if (creado && item.creado && String(item.creado) === String(creado)) return false;
              return !(Number(item.coordenadas[0]) === fx && Number(item.coordenadas[1]) === fy);
            }
            return true;
          });
          localStorage.setItem("puntosGuardados", JSON.stringify(nueva));
        } catch (error) {}

        const modalElement = document.getElementById("modalInfoLocal");
        if (modalElement) modalElement.remove();
      });
    }
  }

  const botonEliminarTodos = document.getElementById("botonEliminarTodosInfoLocal");
  if (botonEliminarTodos) {
    botonEliminarTodos.addEventListener("click", () => {
      let puntosGuardados = [];
      try {
        puntosGuardados = JSON.parse(localStorage.getItem("puntosGuardados")) || [];
      } catch (error) {
        puntosGuardados = [];
      }

      if (puntosGuardados.length === 0) {
        alert("No hay puntos guardados para borrar.");
        return;
      }

      const confirmMsg = "Se eliminarán TODOS los puntos guardados.\n\nPulse Aceptar para crear automáticamente una copia de seguridad (CSV) y proceder a la eliminación.\nPulse Cancelar para abortar la operación.";
      if (!confirm(confirmMsg)) {
        alert("Operación cancelada. No se han realizado cambios.");
        return;
      }

      try {
        const downloadBtn = document.getElementById("downloadPoint");
        if (downloadBtn) {
          downloadBtn.click();
        } else {
          const escapeCsv = (value) => {
            if (value === null || value === undefined) return "";
            const valueAsString = String(value);
            if (valueAsString.includes('"') || valueAsString.includes(",") || valueAsString.includes("\n") || valueAsString.includes("\r")) {
              return '"' + valueAsString.replace(/"/g, '""') + '"';
            }
            return valueAsString;
          };

          const headers = ["x", "y", "titulo", "descripcion", "creado", "color"];
          const lines = [headers.join(",")];
          puntosGuardados.forEach((item) => {
            let coords = null;
            let tituloPunto = "";
            let descripcionPunto = "";
            let creado = "";
            let color = "";

            if (Array.isArray(item) && item.length >= 2) {
              coords = item;
            } else if (item && item.coordenadas) {
              coords = item.coordenadas;
              tituloPunto = item.titulo || "";
              descripcionPunto = item.descripcion || "";
              creado = item.creado || "";
              color = item.color || "";
            }

            if (!coords) return;
            lines.push([
              escapeCsv(coords[0]),
              escapeCsv(coords[1]),
              escapeCsv(tituloPunto),
              escapeCsv(descripcionPunto),
              escapeCsv(creado),
              escapeCsv(color),
            ].join(","));
          });

          const csvContent = lines.join("\r\n");
          const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          const now = new Date();
          const pad = (number) => String(number).padStart(2, "0");
          link.download = `puntosCallejero_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.csv`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(url);
        }
      } catch (error) {}

      const total = puntosGuardados.length;
      try {
        if (customPointsLayer && customPointsLayer.getSource) {
          customPointsLayer.getSource().clear();
        } else if (map) {
          map.getLayers().getArray().forEach((layer) => {
            try {
              if (layer && layer.get("name") === "puntosPersonalizados" && layer.getSource) {
                layer.getSource().clear();
              }
            } catch (error) {}
          });
        }
      } catch (error) {}

      try {
        localStorage.setItem("puntosGuardados", JSON.stringify([]));
      } catch (error) {}

      const modalElement = document.getElementById("modalInfoLocal");
      if (modalElement) modalElement.remove();

      alert(`Copia de seguridad creada correctamente. Se han eliminado ${total} puntos guardados.`);
    });
  }
}
